import { render, staticRenderFns } from "./OutgoingCards.vue?vue&type=template&id=18caf349&"
import script from "./OutgoingCards.vue?vue&type=script&lang=js&"
export * from "./OutgoingCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports